import { VariableValue } from '@components/text-editors/addons/field-mapping';

export const extractRequestHeaders = (
  data: Record<string, unknown>,
): Record<string, VariableValue> => {
  const prefix = 'requestHeaders__';
  const headers: Record<string, VariableValue> = {};
  Object.keys(data).forEach((key) => {
    if (key.startsWith(prefix)) {
      const headerName = key.substring(prefix.length);
      const value = data[key];
      if (!value) return;
      headers[headerName] =
        typeof value !== 'object'
          ? { value: String(value), variables: {} }
          : (value as VariableValue);
    }
  });
  return headers;
};
